import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    customReplyTimeOutDTO: {},
    sessionFinishWordDTO: {},
    startWordsTechniqueDTO: {},
    turnArtificialDTO: {},
    performanceBasicDTO: {},
    performanceStatisticsDTO: {},
    rollbackMessageTimeDTO: {},
    customTelephoneSwitchDTO: {},
    customServerReplyTimeOutDTO: {},
    receptionRingtoneUrlDTO: {},
    offlineMessageAllocationDTO: {},
    customNickNameDTO: {},
	customEvaluateDTO: {}
}

const reducers = createActions({
    getRobotBasicConfigAction: {
        success: (state, action) => {
            const {
                customReplyTimeOutDTO = {},
	            sessionFinishWordDTO = {},
	            startWordsTechniqueDTO = {},
	            turnArtificialDTO = {},
	            performanceBasicDTO = {},
	            performanceStatisticsDTO = {},
	            rollbackMessageTimeDTO = {},
	            customTelephoneSwitchDTO = {},
	            customServerReplyTimeOutDTO = {},
	            receptionRingtoneUrlDTO = {},
	            customAiSwitchDTO = {},
	            offlineMessageAllocationDTO = {},
	            customNickNameDTO = {},
				customEvaluateDTO = {}
            } = action.payload
	        
	        return {
		        ...state,
		        customReplyTimeOutDTO,
		        sessionFinishWordDTO,
		        startWordsTechniqueDTO,
		        turnArtificialDTO,
		        performanceBasicDTO,
		        performanceStatisticsDTO,
		        rollbackMessageTimeDTO,
		        customTelephoneSwitchDTO,
		        customServerReplyTimeOutDTO,
		        receptionRingtoneUrlDTO,
		        customAiSwitchDTO,
		        offlineMessageAllocationDTO,
		        customNickNameDTO,
				customEvaluateDTO
	        }
        }
    }
}, actions)

const servicioSettingSlice = createSlice({
    name: 'servicioSetting',
    initialState,
    ...reducers
})

export const getCustomReplyTimeOutDTO = state => state.servicioSetting.customReplyTimeOutDTO
export const getSessionFinishWordDTO = state => state.servicioSetting.sessionFinishWordDTO
export const getCustomEvaluateDTO = state => state.servicioSetting.customEvaluateDTO
export const getStartWordsTechniqueDTO = state => state.servicioSetting.startWordsTechniqueDTO
export const getTurnArtificialDTO = state => state.servicioSetting.turnArtificialDTO
export const getPerformanceBasicDTO = state => state.servicioSetting.performanceBasicDTO
export const getPerformanceStatisticsDTO = state => state.servicioSetting.performanceStatisticsDTO
export const getRollbackMessageTimeDTO = state => state.servicioSetting.rollbackMessageTimeDTO
export const getCustomAiSwitchDTO = state => state.servicioSetting.customAiSwitchDTO
export const getCustomTelephoneSwitchDTO = state => state.servicioSetting.customTelephoneSwitchDTO
export const getCustomServerReplyTimeOutDTO = state => state.servicioSetting.customServerReplyTimeOutDTO
export const getReceptionRingtoneUrlDTO = state => state.servicioSetting.receptionRingtoneUrlDTO
export const getOfflineMessageAllocationDTO = state => state.servicioSetting.offlineMessageAllocationDTO
export const getCustomNickNameDTO = state => state.servicioSetting.customNickNameDTO

export default servicioSettingSlice
